// Small pure helpers for recipe / weekly-plan documents, shared between MealPlan and its
// hooks (useRecipeActions, and later useWeeklyPlan). These were previously local to
// MealPlan.jsx; extracted so both the component and the hooks can use one copy.

// Derive a full-size image URL from the common shapes recipe/plan docs come in.
export const deriveImageUrl = (raw) => {
  if (!raw) return '';
  if (typeof raw.image === 'string') return raw.image;
  const nested = raw.image?.src || raw.image?.url;
  if (nested) return nested;
  if (Array.isArray(raw.imageUrls) && raw.imageUrls.length) return raw.imageUrls[0];
  return raw.image_url || '';
};

// Derive a thumbnail URL, falling back through the common field names (and nested recipe).
export const deriveImageThumbUrl = (raw) => {
  if (!raw) return '';
  if (typeof raw.imageThumb === 'string' && raw.imageThumb) return raw.imageThumb;
  if (typeof raw.thumbnail === 'string' && raw.thumbnail) return raw.thumbnail;
  if (typeof raw.thumbUrl === 'string' && raw.thumbUrl) return raw.thumbUrl;
  if (raw.recipe) return deriveImageThumbUrl(raw.recipe);
  return '';
};

// True for a 24-hex-char Mongo ObjectId string.
export const isObjectId = (s) => typeof s === 'string' && /^[a-f0-9]{24}$/i.test(s);
